import { reportElementClasses } from './registry';
import type { ReportElementConstructor } from './types';

function createElementClassMap(): ReadonlyMap<string, ReportElementConstructor> {
    const classMap = new Map<string, ReportElementConstructor>();

    (reportElementClasses as readonly ReportElementConstructor[]).forEach((ElementClass) => {
        if (classMap.has(ElementClass.elementType)) {
            throw new Error(`Duplicate element type "${ElementClass.elementType}" in registry.`);
        }

        classMap.set(ElementClass.elementType, ElementClass);
    });

    return classMap;
}

const ELEMENT_CLASS_BY_TYPE = createElementClassMap();

export function requireReportElementClass(elementType: string): ReportElementConstructor {
    const ElementClass = ELEMENT_CLASS_BY_TYPE.get(elementType);
    if (ElementClass) {
        return ElementClass;
    }

    throw new Error(`No element class registered for element type "${elementType}".`);
}
